export const comments_3296181 = {"data":{"data":[],"links":{}}}